<div class="carousel-wrapper-parent">
  <div class="logo-wrapper">
    <img src="/assets/img/3ddv/3ddv_vw.svg" />
  </div>
  <!-- noWrap: noloop-->
  <carousel [noWrap]="false" [showIndicators]="true" [noPause]="true" [isAnimated]="true">
    <slide *ngFor="let slide of slides; let index = index">
      <img [src]="slide.image" class="slide" alt="image slide" style="display: block; width: 100%" />
    </slide>
  </carousel>
  <div class="login-page">
    <div>
      <div class="login-wrapper">
        <div>
          <div class="login-wrapper-top">
            <h2>{{ 'login.title' | translate }}<br />{{ 'venueworkspace' | translate }}</h2>
            <span>{{ 'login.subtitle' | translate }}</span>
          </div>
          <div class="login-wrapper-body">
            <form class="form-floating">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  class="form-control"
                  name="username"
                  id="floatingInput"
                  placeholder="name@example.com"
                  [(ngModel)]="user.username" />
                <label for="floatingInput">Email</label>
              </div>
              <div class="form-floating">
                <input
                  type="password"
                  class="form-control"
                  id="floatingPassword"
                  name="password"
                  placeholder="Password"
                  [(ngModel)]="user.password" />
                <label for="floatingPassword">Password</label>
              </div>
            </form>
            <div class="mb-5">
              <a
                routerLink="/forgot"
                style="float: right; text-decoration: none; color: rgba(0, 0, 0, 0.602); font-weight: 500"
                class="my-3"
                >Forgot password?</a
              >
            </div>
            <div class="alert alert-danger mt-3 mb-3" role="alert" *ngIf="errMsg">
              {{ errMsg }}
            </div>
          </div>

          <div class="login-wrapper-bottom">
            <button class="btn-login-main" type="submit" (click)="login()">Log In</button>
          </div>
        </div>
      </div>
      <div class="login-page-bottom">
        <button class="btn-login-secondary" type="button" (click)="sendEmail()">
          Don't you have an account? Contact us
        </button>
      </div>
    </div>
  </div>
</div>
